import { Injectable } from '@angular/core';
import { InvoiceService, ChargeTransactions } from '@app/core';
import { Observable } from 'rxjs';

@Injectable()
export class DataLoaders {

   constructor(private invoiceService: InvoiceService) { }

   getChargeListAll(model): Observable<ChargeTransactions[]> {
        return this.invoiceService.getChargeListAll(model);
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/loaders/data-loaders.ts